<template>

<div class="main list-view no-sub-header">

	<div class="filters">
		<label>Department</label>
        <select v-model="filters.department_id" @change="filters.page = 1; getList()">
            <option value="">Select...</option>
            <option v-for="department in departments" :value="department.department_id">{{ department.description }}</option>
        </select>
		<label>Product</label>
		<input type="search" v-model="filters.search_term" placeholder="UPC Search..." @search="filters.page = 1; getList()">
		<div class="divider"></div>
        <div class="button neutral" @click="clearFilters()">Clear Filters</div>
		<div v-if="getDevEnvironment" class="extra-menu-item" @click="getList()">Reload Report</div>
	</div>

	<div class="list report-list" style="margin: 0 1em;">

		<div class="printable-heading">Top Sellers by Department</div>

		<div v-if="loading" class="empty-list"></div>

		<div v-else-if="filters.department_id || filters.search_term">

			<div v-if="list.length == 0" class="empty-list">
				This list is empty
			</div>

			<div v-else>
				<div class="two-columns">
					<div style="font-size: 1.25em; font-weight: bold; margin: 0 0 0.5em 0;">{{ filters.search_term ? 'UPC ' + filters.search_term : departmentName(filters.department_id) }}</div>
					<div class="right">
						<pagination :paging="paging" @updatePage="goToPage"></pagination>
					</div>
				</div>
				<table class="data-list" cellpadding="0" cellspacing="0">
					<thead>
						<tr>
							<th class="list" style="width: 60px; padding: 0.5em;"></th>
							<th class="list">Product</th>
							<th class="list right">Units Sold</th>
							<th class="list right">Retail Total</th>
							<th class="list right">Distributor<br>Available</th>
							<th class="list"></th>
						</tr>
					</thead>
					<tr v-for="item in list" class="clickable-list-item">
						<td class="list tiny-image center" style="width: 60px; padding: 0.5em;"><img :src="item.image_src" style="max-width: 100%;"></td>
						<td class="list left">{{ item.description }}<div class="meta"><label>ID: </label>{{ item.product_id }} <label>UPC: </label>{{ item.upc }}</div></td>
						<td class="list right">{{ item.sold }}</td>
						<td class="list right">{{ $formatCurrency(item.price_sold) }}</td>
						<td class="list right">{{ item.available }}</td>
						<td v-if="item.client_id || item.available == 0" class="list extra-menu"></td>
						<td v-else class="list extra-menu right" @click="addToCart(item)">
							<i :class="['fas fa-shopping-cart', { adding_to_cart: item.adding_to_cart }, { in_cart: item.in_cart }]"></i>
							<div :class="['extra-menu-label', { adding_to_cart: item.adding_to_cart }]">{{ item.in_cart ? 'In Cart' :  (item.adding_to_cart ? 'Adding' : 'Add to Cart') }}</div>
						</td>
					</tr>
				</table>
				<div class="right v-spaced">
					<pagination :paging="paging" @updatePage="goToPage"></pagination>
				</div>
			</div>
		</div>
		<div v-else>
			<div style="margin: 0 0 2em 0;">
				<table class="data-list" cellpadding="0" cellspacing="0">
					<thead>
						<tr>
							<th class="list">Department</th>
							<th class="list" style="width: 60px; padding: 0.5em;"></th>
							<th class="list">Product</th>
							<th class="list right">Units Sold</th>
							<th class="list right">Retail Total</th>
							<th class="list right">Distributor<br>Available</th>
							<th class="list"></th>
						</tr>
					</thead>
					<tr v-for="item in list" class="clickable-list-item">
						<td class="list left" @click="goToDepartment(item.department_id)">{{ departmentName(item.department_id) }}</td>
						<td class="list tiny-image center" style="width: 60px; padding: 0 0.5em;" @click="goToDepartment(item.department_id)"><img :src="item.image_src" style="max-width: 100%;"></td>
						<td class="list left" @click="goToDepartment(item.department_id)">{{ item.description }}<div class="meta"><label>ID: </label>{{ item.product_id }} <label>UPC: </label>{{ item.upc }}</div></td>
						<td class="list right" @click="goToDepartment(item.department_id)">{{ item.sold }}</td>
						<td class="list right" @click="goToDepartment(item.department_id)">{{ $formatCurrency(item.price_sold) }}</td>
						<td class="list right" @click="goToDepartment(item.department_id)">{{ item.available }}</td>
						<td v-if="item.client_id || item.available == 0" class="list extra-menu"></td>
						<td v-else class="list extra-menu right" @click="addToCart(item)">
							<i :class="['fas fa-shopping-cart', { adding_to_cart: item.adding_to_cart }, { in_cart: item.in_cart }]"></i>
							<div :class="['extra-menu-label', { adding_to_cart: item.adding_to_cart }]">{{ item.in_cart ? 'In Cart' :  (item.adding_to_cart ? 'Adding' : 'Add to Cart') }}</div>
						</td>
					</tr>
				</table>
				<div class="note v-spaced">Select a department to see more top sellers.</div>
			</div>

		</div>

	</div>
	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>

export default {
	name: 'top-sales',
	data() {
		return {
            loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			filters: {},
			departments: [],
			list: [],
			paging: {},
			totals: {},
			addingToCart: false
		}
	},
	created() {
		this.clearFilters()
		this.getDepartments()
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				do_export: false,
				department_id: ''
			}
			this.getList()
		},
		getDepartments() {
			this.apiCall({ destination: 'get_list_departments', data: { inventory_only: true } }).then(obj => {
				this.departments = obj.departments
			}).catch(err => {
				console.log(err)
			})
		},
		departmentName(departmentId) {
			let department = this.departments.find(department => department.department_id == departmentId)
			return department ? department.description : 'N/A'
		},
		getList() {
			this.loading = true
			this.message = 'Generating report...'
			let apiURL = ''
			if (this.getDevEnvironment && document.location.hostname.indexOf('cdssandbox') == -1) {
				apiURL = 'https://compassapi.test/api.php'
			} else {
				apiURL = 'https://app.nssncompass.com/api.php'
			}
			this.apiCall({ destination: apiURL + '?action=get_report_top_sales', data: this.filters }).then(obj => {
				this.loading = false
				this.message = obj.message
				this.messageStatus = obj.status
				this.list = obj.list
				if (obj.paging) {
					this.paging = obj.paging
				}
			}).catch(err => {
				this.loading = false
				this.messageStatus = 'error'
				this.message = "There was an error loading this report."
			})
		},
		goToDepartment(departmentId) {
			this.filters.page = 1
			this.filters.department_id = departmentId
			this.getList()
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		addToCart(item) {
			if (this.addingToCart) { return false }
			this.addingToCart = true
			item.adding_to_cart = true
			let addQuantity = item.quantity || 1
			this.apiCall({ destination: 'add_to_dealer_cart', data: { product_id: item.product_id, quantity: addQuantity } }).then(obj => {
				this.addingToCart = false
				if (obj.status == 'success') {
					item.adding_to_cart = false
					item.in_cart = true
				}
			}).catch(err => {
				console.log(err)
			})
		},
		printWindow() {
			window.print()
		}
	}
}
</script>
